"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Notifications/Sections/DeviceSection.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);



var _notification = require('web/services/notification');
var _notifications = require('shared/services/notifications');
var _log = require('shared/log');

var _Link = require('web/components/Settings/Link'); var _Link2 = _interopRequireDefault(_Link);
var _NotificationSoundPicker = require('web/components/NotificationSoundPicker'); var _NotificationSoundPicker2 = _interopRequireDefault(_NotificationSoundPicker);
var _Form = require('web/components/Form');

const DEFAULT_SOUND = 'ping.wav'

// Two separate switches: BloomText's own "on for this device" and the
// browser's permission. The toggle shows BloomText's; a warning shows when the
// browser blocks what BloomText has on.
const resolvePermissions = (userKey) => ({
  browserPermission: _notification.hasBrowserPermission.call(void 0, ),
  areNotificationsEnabled: _notification.getCookiePermission.call(void 0, userKey),
})

const openSystemNotificationSettings = _optionalChain([window, 'access', _ => _.ELECTRON, 'optionalAccess', _2 => _2.openNotificationSettings])









const DeviceSection = ({
  showNoticeBar,
  userKey,
  currentSoundUrl = DEFAULT_SOUND,
  onSoundUrlChange,
}) => {
  const audioRef = _react.useRef(null)
  const [permissions, setPermissions] = _react.useState.call(void 0, () => resolvePermissions(userKey))
  const [isSoundPickerModalOpen, setIsSoundPickerModalOpen] = _react.useState.call(void 0, false)
  const { browserPermission, areNotificationsEnabled } = permissions

  const updatePermissions = () => setPermissions(resolvePermissions(userKey))

  // Re-check when the user comes back from the browser's or system's settings.
  _react.useEffect.call(void 0, () => {
    const recheck = () => setPermissions(resolvePermissions(userKey))
    window.addEventListener('focus', recheck)
    document.addEventListener('visibilitychange', recheck)
    return () => {
      window.removeEventListener('focus', recheck)
      document.removeEventListener('visibilitychange', recheck)
    }
  }, [userKey])

  const askBrowserPermission = () =>
    _notification.askForPermissionFunction.call(void 0, updatePermissions, updatePermissions)

  const addToCookie = () => {
    _log.log.info("Adding current user to notification cookie.")
    _notification.addUserCookiePermission.call(void 0, userKey)
    // When the browser blocks them, the inline warning says so instead.
    if (browserPermission === true) {
      showNoticeBar({
        type: "success",
        text: "Notifications are now enabled for this device.",
      })
    }
    updatePermissions()
  }

  const turnOnNotifications = () => {
    addToCookie()
    if (browserPermission === null) askBrowserPermission()
  }

  const turnOffNotifications = () => {
    _log.log.info("Removing current user from notification cookie.")
    _notification.removeUserCookiePermission.call(void 0, userKey)
    showNoticeBar({
      type: "success",
      text: "You will no longer receive notifications on this device.",
    })
    updatePermissions()
  }

  const handleChange = (val) => val
    ? turnOnNotifications()
    : turnOffNotifications()

  const openSoundPickerModal = () => setIsSoundPickerModalOpen(true)
  const closeSoundPickerModal = () => setIsSoundPickerModalOpen(false)

  const playSound = (sound) => {
    const filePath = _notifications.webSoundFileLocation.call(void 0, sound)
    audioRef.current && audioRef.current.pause()
    audioRef.current = new Audio(filePath)
    const played = audioRef.current.play()
    if (played !== undefined) {
      played.catch(e => _log.log.info("Couldn't play audio", filePath, e))
    }
  }

  const playCurrentSound = () => {
    if (currentSoundUrl) {
      playSound(currentSoundUrl)
    }
  }

  const handleSubmitSound = (soundUrl) => {
    _actions2.default.setGlobalNotificationSound(soundUrl)
      .then(() => showNoticeBar({
        type: "success",
        text: "Successfully set notification sound.",
      }))
      .then(() => onSoundUrlChange(soundUrl))
      .catch(() => {
        showNoticeBar({
          type: "warning",
          text: "Failed to set notification sound.",
        })
      })
    closeSoundPickerModal()
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "settings--notifications--device-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}}
        , _react2.default.createElement(_Form.Toggle, {
          isChecked: areNotificationsEnabled,
          onChange: handleChange,
          label: "Enable push notifications on this device"     ,
          hint: `You will ${areNotificationsEnabled ? '' : 'not '}receive push notifications for new messages on this device.`,
          warning: areNotificationsEnabled && browserPermission !== true && (
            browserPermission === null
              ? (
                _react2.default.createElement(_react2.default.Fragment, null, "Notifications are on in BloomText. Allow them in this browser to get alerts."
                              , ' '
                  , _react2.default.createElement(_Link2.default, { onClick: askBrowserPermission, __self: this, __source: {fileName: _jsxFileName, lineNumber: 141}}, "Allow notifications" )
                )
                )
              : 'Notifications are on in BloomText, but this browser is blocking them. To unblock them, click the icon at the left of the address bar, open the site settings, set Notifications to Allow, then come back to this tab.'

          ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}}
        )
        ,  areNotificationsEnabled && openSystemNotificationSettings && (
          _react2.default.createElement('p', { className: "settings--notifications--system-hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 149}}, "Not getting notifications? Your computer may be blocking BloomText."
                    , ' '
            /* No arguments: the desktop bridge can't pass a click event across. */
            , _react2.default.createElement(_Link2.default, { onClick: () => openSystemNotificationSettings(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 152}}, "Open notification settings"  )
          )
        )
      )
      ,  areNotificationsEnabled &&
        _react2.default.createElement('div', { className: "settings--notifications--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 157}}
          , _react2.default.createElement('h5', { className: "settings--notifications--section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 158}}, "Notification Sound"

          )
          , _react2.default.createElement('div', { className: "settings--notifications--sound-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}
            , _react2.default.createElement('div', {
              className: "settings--notifications--sound-btn",
              onClick: playCurrentSound, __self: this, __source: {fileName: _jsxFileName, lineNumber: 162}}

              , _react2.default.createElement('span', { className: "settings--notifications--sound-play-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 166}}
                , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 167}}, "play_arrow")
              )
              , _react2.default.createElement('span', { className: "settings--notifications--sound-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 169}}
                ,  _notifications.getSoundName.call(void 0, currentSoundUrl, "None") 
              )
            )
            , _react2.default.createElement(_Link2.default, {
              className: "settings--notifications--sound-change-btn",
              onClick: openSoundPickerModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 173}}
, "Change sound"

            )
          )
          , _react2.default.createElement(_NotificationSoundPicker2.default, {
            key: currentSoundUrl,
            isOpen: isSoundPickerModalOpen,
            onClose: closeSoundPickerModal,
            defaultChosenSound: currentSoundUrl,
            noneLabel: "None",
            onSubmit: handleSubmitSound, __self: this, __source: {fileName: _jsxFileName, lineNumber: 180}}
          )
        )
      
    )
  )
}

exports. default = DeviceSection
